import { Stack } from 'expo-router';

export default function LeagueRoutesLayout() {
  // Keep [id] as its own stack route. Expo Router can then replace the dynamic
  // league segment at this navigator when switching leagues, so native tabs
  // cannot retain another league's route params.
  return <Stack screenOptions={{ headerShown: false, animation: 'none' }} />;
}
